import React from 'react';
import {
    RightControllerButton,
    StyledWrapper,
    StyledInput,
    ArrowIcon,
} from '../search-dropdown.style';
import { Modal } from '../../modal/modal';
import { stringifyItem } from '../common/helpers';
import { ISelectProps, IItem } from '../common/interface';
import { CrossButton } from '../common/controller-buttons';
import { SelectBox } from './select-box';

const MobileSelect = (props: ISelectProps) => {
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [inputSelectedItem, setInputSelectedItem] = React.useState<IItem | null>(null);
    const allHeadingItem: IItem = {
        key: '',
        title: props.selectAllText,
    };

    const onSelectHandler = (selectedItem: IItem | null) => {
        if (selectedItem) {
            setIsModalOpen(false);
        }

        // provides a way for the dropdown to be controlled and uncontrolled
        if (props.selectedItem === undefined) {
            setInputSelectedItem(selectedItem);
        }
        props.onSelectHandler(selectedItem);
    };

    // provides a way for the dropdown to be controlled and uncontrolled
    const selectedItem = props.selectedItem === undefined ? inputSelectedItem : props.selectedItem;

    return (
        <>
            <StyledWrapper>
                <StyledInput
                    data-testid="select-menu-input"
                    onClick={() => setIsModalOpen(true)}
                    value={selectedItem ? stringifyItem(selectedItem) : props.heading}
                    placeholder={props.placeholder}
                    style={{ height: '50px' }}
                    aria-label={`select ${props.heading}`}
                    readOnly
                    data-testid-value={props.selectedItem ? props.selectedItem.key : null}
                />
                {selectedItem ? (
                    <CrossButton
                        onClickHandler={() => {
                            setIsModalOpen(true);
                            onSelectHandler(null);
                        }}
                        ariaLabel="clear selection"
                    />
                ) : (
                    <RightControllerButton
                        data-testid="open-menu-btn"
                        style={{ outline: 'none' }}
                        tabIndex="-1"
                        onClick={() => setIsModalOpen(true)}
                        aria-label="open menu"
                    >
                        <ArrowIcon />
                    </RightControllerButton>
                )}
            </StyledWrapper>
            <Modal
                showModal={isModalOpen}
                headerText={props.heading}
                onClose={() => setIsModalOpen(false)}
                data-testid={`${props.category}-modal`}
            >
                <SelectBox
                    placeholder={selectedItem ? stringifyItem(selectedItem) : props.placeholder}
                    items={props.items}
                    onSelectHandler={onSelectHandler}
                    allHeadingItem={allHeadingItem}
                    heading={props.heading}
                    selectAllText={props.selectAllText}
                    selectedItem={props.selectedItem}
                    category={props.category}
                    stateReducer={props.stateReducer}
                    {...(props.selectedItem !== undefined && { selectedItem })}
                    isModalOpen={isModalOpen}
                />
            </Modal>
        </>
    );
};

export default MobileSelect;
